  
	<div class="py-2">
		<div class="container">
		  <!--div class="row">
			<div class="col-md-3 offset-md-9">
			  <form class="form-inline">
				<div class="input-group">
				  <input type="text" class="form-control" placeholder="Username">
				  <div class="input-group-append">
					<button class="btn btn-primary" type="button">Filter</button>
				  </div>
				</div>
			  </form>
			</div>
		  </div-->
		  <div class="row">
			<!--div class="col-md-8  py-1">
			
			<div *ngIf="rtnStatusData && rtnStatusData.success == true" class="alert alert-success">
				{{ rtnStatusData.message }}
			</div>
			  <table class="table">
				<thead>
				  <tr>
					<th>#</th>
					<th>Account Name</th>
					<th>Project Name</th>
					<th>Project Details</th>
					<th>Project Identifier</th>
					<th>Action</th>
				  </tr>
				</thead>
				<tbody>
				  <tr *ngFor="let adata of projectData; let i = index">
					<td>#{{i + 1}}</td>
					<td>{{ adata.accountName }}</td>
					<td>{{ adata.projectName }}</td> 
					<td>{{ adata.projectDetails }}</td>
					<td>{{ adata.projectIdentifier }}</td>
					<td> <i class="fa d-inline fa-lg fa-edit " (click)="accountEdit(adata._id, adata.projectid)" ></i> <i class="fa d-inline fa-lg fa-trash-o" (click)="deleteProject(adata._id, adata.projectid)"></i></td>
				  </tr>              
				</tbody>
			  </table>
			 
			</div-->
			<div class="col-md-12 py-1">
				<form (ngSubmit)="onSubmit(projectForm, model.id, model.projectid)" #projectForm="ngForm" encType="multipart/form-data">
				<div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
						{{ rtnData.message }}
				 </div>
			   <div class="form-group"> <label for="projectName">Project Name</label>
				  <input type="text" required class="form-control" id="projectName" placeholder="Enter Project Name" name="projectName" #projectName="ngModel" [(ngModel)]="model.projectName"> 
				  <div *ngIf="rtnData && rtnData.message.projectName" class="alert alert-danger">
						{{rtnData.message.projectName}}
				 </div>
				</div>
				
				
				<div class="form-group"> <label for="projectDetails">Project Details</label>
				  <!--input type="text" required class="form-control" id="accountDetails" placeholder="Enter Project Details" name="accountDetails" #accountDetails="ngModel" [(ngModel)]="model.accountDetails"--> 
				  <textarea required class="form-control" id="projectDetails" placeholder="Enter Project Details" name="projectDetails" #projectDetails="ngModel" [(ngModel)]="model.projectDetails"> </textarea>
				  <div *ngIf="rtnData && rtnData.message.projectDetails" class="alert alert-danger">
						{{rtnData.message.projectDetails}}
				 </div>
				 </div>
				 
				 
			   <div class="form-group"> <label for="projectIdentifier">Project Identifier</label>
				  <input type="text" oninput="this.value = this.value.toLowerCase()" required class="form-control" id="projectIdentifier" placeholder="Enter Project Identifier" name="projectIdentifier" #projectIdentifier="ngModel" [readonly]="model.projectid!=''" [(ngModel)]="model.projectIdentifier"> 
				  <div *ngIf="rtnData && rtnData.message.projectIdentifier"  class="alert alert-danger">
						{{rtnData.message.projectIdentifier}}
				 </div>
				</div>
				 
				 <div class="form-group" ngModelGroup="projectServices"> <label for="projectServices">Project Services</label>
					<!--div>
					<select multiple name="projectServices" [(ngModel)]="model.projectServices">
						<option *ngFor="let generic of genericServices" [value]="generic.value" selected>  
							{{generic.service}}
						</option>
					</select>
					</div-->

				 	
					 <div *ngFor="let generic of genericServices; let i = index;" class="form-check" style="padding-right:20px;">
						<label class="form-check-label">
						  <input type="checkbox" class="form-check-input" [(ngModel)]="model.projectServices[generic.value]" name = "{{generic.value}}" ng-true-value="generic.value" ng-false-value="'false'" ><span class="chk_txt"> {{generic.service}}</span>
						</label><!--[(ngModel)]="model.projectServices[generic.value]"-->
					  </div> 
					
					<div *ngIf="rtnData && rtnData.message.projectServices" class="alert alert-danger">
							{{rtnData.message.projectServices}}
					</div>
				 </div>
				 
				 <div class="form-group" ngModelGroup="projectComponents"> <label for="projectComponents">Project Componenets</label>
					 <div *ngFor="let generic of genericComponents; let i = index;" class="form-check" style="padding-right:20px;">
						<label class="form-check-label">
						  <input type="checkbox" class="form-check-input" [(ngModel)]="model.projectComponents[generic.value]" name = "{{generic.value}}" ng-true-value="generic.value" ng-false-value="'false'" ><span class="chk_txt"> {{generic.service}}</span>
						</label><!--[(ngModel)]="model.projectServices[generic.value]"-->
					  </div> 
					
					<div *ngIf="rtnData && rtnData.message.projectComponents" class="alert alert-danger">
							{{rtnData.message.projectComponents}}
					</div>
				 </div>
				 
				 <!--div class="form-group"> <label for="projectServices">Project Services</label>
					<div>
					<input type="file" name="projectLogo" />
					</div>
				 </div-->
				 
				 
				 <!--div class="form-group"> <label for="projectPaymentMode">Payment Mode Type</label>
					 <div >
						<label *ngFor="let payMode of paymentModeServices">
						<input type="radio" name="projectPaymentMode" #projectPaymentMode="ngModel" [(ngModel)]="model.projectPaymentMode" [value]="payMode.id">
						{{payMode.name}}
						</label>
					</div>
				  
				  <div *ngIf="rtnData && rtnData.message.projectPaymentMode" class="alert alert-danger">
						{{rtnData.message.projectPaymentMode}}
				 </div>
				</div> 
				 <div class="form-group"> <label for="projectPaymentType">Payment Gateway Type</label>
					 <div >
						<label *ngFor="let payVendor of paymentVendorServices">
						<input type="radio" name="projectPaymentType" #projectPaymentType="ngModel" [(ngModel)]="model.projectPaymentType" [value]="payVendor.id">
						{{payVendor.name}}
						</label>
					</div>
				  
				  <div *ngIf="rtnData && rtnData.message.projectPaymentType" class="alert alert-danger">
						{{rtnData.message.projectPaymentType}}
				 </div>
				 
				 
				 </div-->
				 <div class="text-right">
				<button type="submit" class="btn btn-primary">{{ (model.projectid)?"Update":"Create" }}</button>
				<button type="button" (click)="clearFormData()" class="btn btn-secondary">Cancel</button>
				 </div>
			  </form>
			</div>
		  </div>
		</div>
	  </div> 